const VisPageLogout = () => import('@/views/vis-page-logout');

export default [
  {
    path: "/logout",
    name: "logout",
    component: VisPageLogout,
    props: route => ({ state: route.query.state })
  }
]
